export default "__VITE_ASSET__76a2ea76__"